// WordPress Image Fixer for Shopify
// Catches broken womensbest.blog images and replaces with correct URLs
// Load wp-image-map.js BEFORE this script

(function() {
  if (!window.wpImageMap) {
    console.warn('[WP Image Fixer] wp-image-map.js not loaded');
    return;
  }

  var map = window.wpImageMap;
  var fixed = 0;

  function getPathFromUrl(url) {
    try {
      var u = new URL(url);
      return u.pathname;
    } catch(e) {
      return url;
    }
  }

  function stripSizeSuffix(path) {
    return path.replace(/-\d+x\d+/g, '');
  }

  function lookupUrl(originalUrl) {
    var path = getPathFromUrl(originalUrl);
    var newUrl = map[path];

    if (!newUrl) {
      newUrl = map[stripSizeSuffix(path)];
    }

    if (!newUrl) {
      var lowerPath = path.toLowerCase();
      for (var key in map) {
        if (key.toLowerCase() === lowerPath || stripSizeSuffix(key.toLowerCase()) === stripSizeSuffix(lowerPath)) {
          newUrl = map[key];
          break;
        }
      }
    }

    return newUrl;
  }

  function fixImage(img) {
    var didFix = false;

    // Fix src attribute
    var src = img.getAttribute('src') || '';
    if (src.indexOf('womensbest.blog') !== -1) {
      var newUrl = lookupUrl(src);
      if (newUrl) {
        img.setAttribute('src', newUrl);
        var srcset = img.getAttribute('srcset');
        if (srcset) img.removeAttribute('srcset');
        didFix = true;
        fixed++;
      }
    }

    // Fix data-src attribute (lazy-loaded images)
    var dataSrc = img.getAttribute('data-src') || '';
    if (dataSrc.indexOf('womensbest.blog') !== -1) {
      var newDataUrl = lookupUrl(dataSrc);
      if (newDataUrl) {
        img.setAttribute('data-src', newDataUrl);
        // Also update src if it points to womensbest.blog
        if (src.indexOf('womensbest.blog') !== -1) {
          img.setAttribute('src', newDataUrl);
        }
        didFix = true;
        fixed++;
      }
    }

    // Reset lazy loader error state and reload
    if (didFix) {
      img.removeAttribute('data-ll-status');
      img.classList.remove('error', 'entered');
      img.classList.add('loaded');
    }
  }

  // Fix all images on page load (src or data-src)
  document.querySelectorAll('img[src*="womensbest.blog"], img[data-src*="womensbest.blog"]').forEach(fixImage);

  // Also catch images that fail to load
  document.addEventListener('error', function(e) {
    if (e.target.tagName === 'IMG') fixImage(e.target);
  }, true);

})();
